/* eslint-disable max-statements */
/*
 * @FilePath: /kitchen-offline-web/src/3DEngine/render/renderTypes/renderUType.js
 * @Author: Yongchao Wang
 * @Date: 2021-08-01 14:04:57
 * @LastEditors: Xiaohua Zhu
 * @LastEditTime: 2022-06-23 13:29:31
 */
import { Vector3, Vector2 } from '@babylonjs/core/Maths/math';
import MeshManage from '../../meshManage';
import {
  FRAMECATEGORY,
  FRAMEDEPTH,
  MINIMUM_WALL_WIDTH,
  SKIRTINGBOARDCONFIG,
  TOPFRAME_GROUND,
  GAP_BETWEEN_WALL_AND_CABINET,
} from '../../utils/kitchenConfig';
import { putBottomCornerFrame } from '../../utils/renderUtils';
import RenderBaseType from '../renderBaseType';

import {
  SidePlatePosition, SidePlateSequence, BASICTYPE_ENUM, LengthLocation, BASICRENDER_TYPE,
  CALLOUTLINE_TYPE,
} from '../../utils/enum';
import LengthX from '../../lengthTypes/lengthX';
import LengthZ from '../../lengthTypes/lengthZ';
import LengthP2X from '../../lengthTypes/lengthP2X';
import LengthP2Z from '../../lengthTypes/lengthP2Z';
import Ground from '../../room/ground';
import { renderSkirtingBoardUtil, renderTopPanelUtil } from './renderUTypeUtils';
import { calloutLineFilter } from '../../utils/lengthUtils';


class RenderUType extends RenderBaseType {
  /**
   * @description: 渲染U型顶柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderTop() {
    if (!this?.templateJson?.top?.length1?.frames) {
      return;
    }
    this.putTopCupboard();
    // 渲染补板
    // this.handleSealPlate(BASICTYPE_ENUM.top);
    if (this?.templateJson?.version > '2.2') {
      // this.renderSidePlatesByType(SidePlatePosition.Bottom);
    } else {
      this.renderSidePlates(SidePlatePosition.Top);
    }
  }

  /**
   * @description: 渲染U型底柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderBottom() {
    if (!this?.templateJson?.bottom?.length1?.frames) {
      return;
    }
    this.bottomLength1 = new LengthX(this.templateJson, this.scene, 'bottom', 'length1', this.copyTemplateJson);
    this.bottomLength2 = new LengthZ(this.templateJson, this.scene, 'bottom', 'length2', this.copyTemplateJson);
    this.putBottomCupboard();
    // 渲染补板
    // this.handleSealPlate(BASICTYPE_ENUM.bottom);
    // version2.0 remove by zhanyu.shen 20211229, 单独渲染踢脚板，顶柜有高柜影响踢脚板 see renderEngine/index
    // this.renderSkirtingBoard();
    this.renderTopPanel();
    if (this?.templateJson?.version > '2.2') {
      this.renderSidePlatesByType(SidePlatePosition.Bottom);
    } else {
      this.renderSidePlates(SidePlatePosition.Bottom);
    }
  }


  renderRoom() {
    // 没有墙地面信息不渲染
    if (!this.templateJson?.other) {
      return;
    }
    this.bottomLength2.createWall();
    this.bottomLength3 = new LengthP2X(this.templateJson, this.scene, 'bottom', 'length3', this.copyTemplateJson);
    this.bottomLength4 = new LengthP2Z(this.templateJson, this.scene, 'bottom', 'length4', this.copyTemplateJson);
    const l2Width = this.bottomLength2.getSideLength();

    const l1Width = Math.max(this.bottomLength1.getSideLength(MINIMUM_WALL_WIDTH),
      this.bottomLength3.getSideLength(MINIMUM_WALL_WIDTH), MINIMUM_WALL_WIDTH);
    this.bottomLength1.createWall(l1Width);

    this.bottomLength3.createWall(l1Width, l2Width);
    this.bottomLength4.createWall(l2Width, l1Width);
    const wallInfo = this.templateJson?.other?.wall;
    this.changeWallColor(wallInfo?.baseModelUrl,
      wallInfo?.normalModelUrl, { width: wallInfo?.width * 0.001, height: wallInfo?.height * 0.001 });
    this.groundNode = new Ground(this.scene, this.engine, { width: l1Width, height: l2Width });
    const grounds = [
      new Vector2(0, -GAP_BETWEEN_WALL_AND_CABINET),
      new Vector2(-l1Width, -GAP_BETWEEN_WALL_AND_CABINET),
      new Vector2(-l1Width, l2Width + 2 * GAP_BETWEEN_WALL_AND_CABINET),
      new Vector2(0, l2Width + 2 * GAP_BETWEEN_WALL_AND_CABINET),
    ];
    this.groundNode.createGround(grounds, new Vector3(0, 0, 0));
    this.groundNode.changeMaterial(this.templateJson?.other?.floor?.baseModelUrl,
      this.templateJson?.other?.floor?.normalModelUrl,
      { width: this.templateJson.other.floor.width * 0.001, height: this.templateJson.other.floor.height * 0.001 });
    this.roomMeshes = [
      this?.groundNode?.groundMesh,
      this.bottomLength1?.wallNode?.wallMesh,
      this.bottomLength2?.wallNode?.wallMesh,
      this.bottomLength3?.wallNode?.wallMesh,
      this.bottomLength4?.wallNode?.wallMesh,
    ];
    this.renderWindow();
  }

  renderWindow() {
    const lengthArr = ['length1', 'length2', 'length3'];
    let frame;
    let length;
    let window;
    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < lengthArr.length; index++) {
      const element = lengthArr[index];
      if (!frame) {
        const windowFrame = this.getWindowFrame('bottom', element);
        frame = windowFrame.frame;
        length = windowFrame.length;
        window = windowFrame.window;
        if (frame?.longEdge) {
          length = `length${frame.longEdge}`;
        }
      }
    }
    switch (length) {
      case 'length1':
        this.bottomLength1.createWindow(frame, window);
        this.addMesh(this.bottomLength1?.windowNode?.windowMesh);
        break;
      case 'length2':
        this.bottomLength2.createWindow(frame, window);
        this.addMesh(this.bottomLength2?.windowNode?.windowMesh);
        break;
      case 'length3':
        this.bottomLength3.createWindow(frame, window);
        this.addMesh(this.bottomLength3?.windowNode?.windowMesh);
        break;
      default:
        break;
    }
    // 如果窗户隐藏自动隐藏窗户
    if (!this.windowVisiable) {
      this.showWindow(this.windowVisiable);
    }
  }

  /**
     * @description: 渲染侧板
     * @param {position} 顶柜或顶柜
     * @return {*}
     * @author: Xiaohua Zhu
     */
  renderSidePlates(position) {
    const uTypeLength1 = this.templateJson[position].length1;
    const uTypeLength2 = this.templateJson[position].length2;
    const uTypeLength3 = this.templateJson[position].length3;

    const l1SidePlatesArray = uTypeLength1.sidePlates;
    const l3SidePlatesArray = uTypeLength3.sidePlates;

    if (l1SidePlatesArray) {
      const l1 = this[`${position}Length1`];

      const l1lastFrameJson = uTypeLength1.frames[uTypeLength1.frames.length - 1];

      const l1LastSidePlateRotationData = l1.renderSidePlate(l1lastFrameJson, l1SidePlatesArray,
        uTypeLength1.frames.length === 1 ? SidePlateSequence.Corner : SidePlateSequence.Last, position);
      this.addSidePlatesMeshes(uTypeLength1.sidePlates);

      this.addRotationMeshes(l1LastSidePlateRotationData);
    }
    if (l3SidePlatesArray) {
      const l3 = this[`${position}Length3`];
      let l3lastFrameJson = uTypeLength3.frames[uTypeLength3.frames.length - 1];
      if (!l3lastFrameJson) {
        l3lastFrameJson = uTypeLength2.frames[uTypeLength2.frames.length - 1];
        const l3LastSidePlateRotationData = l3.renderSidePlate(l3lastFrameJson, l3SidePlatesArray,
          SidePlateSequence.Corner, position);
        this.addRotationMeshes(l3LastSidePlateRotationData);
      } else {
        const l3LastSidePlateRotationData = l3.renderSidePlate(l3lastFrameJson, l3SidePlatesArray,
          SidePlateSequence.Last, position);
        this.addRotationMeshes(l3LastSidePlateRotationData);
      }
      this.addSidePlatesMeshes(uTypeLength3.sidePlates);
    }
  }

  renderSidePlatesByType(position) {
    const lTypeLength1 = this.templateJson[position].length1;
    const lTypeLength2 = this.templateJson[position].length2;
    const lTypeLength3 = this.templateJson[position].length3;
    const length1SidePlatesArr = lTypeLength1.sidePlatesV2;
    const length2SidePlatesArr = lTypeLength2.sidePlatesV2;
    const length3SidePlatesArr = lTypeLength3.sidePlatesV2;
    this[`${position}Length1`].renderSidePlateByLength(length1SidePlatesArr, position);
    this[`${position}Length2`].renderSidePlateByLength(length2SidePlatesArr, position);
    this[`${position}Length3`].renderSidePlateByLength(length3SidePlatesArr, position);
    if (this.refrigeraror?.type === position) {
      this[`${position}Length${this.refrigeraror.length}`].setRefrigerator(this.refrigeraror, position);
    }
  }

  setCalloutLine() {
    if (this.templateJson.bottom.type === 'U' || this.templateJson.bottom.type === 'U_S') {
      this.setBottomCalloutLine();
    }
    // version2.0 无顶柜的时候top为null
    if (this.templateJson.top?.type === 'U') {
      this.setTopCalloutLine();
    }
  }

  setBottomCalloutLine() {
    const { Length, EndHeight, EndDepth } = CALLOUTLINE_TYPE;
    const lTypeL1ShowList = [Length, EndHeight, EndDepth];
    const lTypeL2ShowList = [Length];
    const lTypeL3ShowList = [Length];
    const lTypeL3HighAndLowShowList = [Length, EndHeight, EndDepth];
    const isHighAndLow = this.templateJson.bottom.highAndLow;
    const isUSType = this.templateJson.bottom.type === BASICRENDER_TYPE.U_S;
    const calloutLineLength1 = this.bottomLength1?.getFramesCalloutLine(LengthLocation.Bottom);
    const calloutLineLength2 = this.bottomLength2?.getFramesCalloutLine(LengthLocation.Bottom);
    const calloutLineLength3 = this.bottomLength3?.getFramesCalloutLine(LengthLocation.Bottom);
    const calloutLines = {
      length1: calloutLineFilter(lTypeL1ShowList, calloutLineLength1),
      length2: calloutLineFilter(lTypeL2ShowList, calloutLineLength2),
      length3: isHighAndLow || isUSType ? calloutLineFilter(lTypeL3HighAndLowShowList, calloutLineLength3)
        : calloutLineFilter(lTypeL3ShowList, calloutLineLength3),
    };
    this.calloutLineInfo.bottom = calloutLines;
  }

  setTopCalloutLine() {
    const { Length, EndHeight, EndDepth } = CALLOUTLINE_TYPE;
    const lTypeL1ShowList = [Length, EndHeight, EndDepth];
    const lTypeL2ShowList = [Length];
    const lTypeL3ShowList = [Length, EndHeight, EndDepth];
    const calloutLineLength1 = this.topLength1?.getFramesCalloutLine(LengthLocation.Top);
    const calloutLineLength2 = this.topLength2?.getFramesCalloutLine(LengthLocation.Top);
    const calloutLineLength3 = this.topLength3?.getFramesCalloutLine(LengthLocation.Top);
    const calloutLines = {
      length1: calloutLineFilter(lTypeL1ShowList, calloutLineLength1),
      length2: calloutLineFilter(lTypeL2ShowList, calloutLineLength2),
      length3: calloutLineFilter(lTypeL3ShowList, calloutLineLength3),
    };
    this.calloutLineInfo.top = calloutLines;
  }


  /**
   * @description: 渲染台面
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderTopPanel() {
    renderTopPanelUtil(this);
  }


  /**
   * @description:渲染踢脚板
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  renderSkirtingBoard() {
    renderSkirtingBoardUtil(this);
  }

  /**
   * @description: 摆放底柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  putBottomCupboard() {
    // 底柜补板数据
    const sealPlateData = this.getLengthSealPlate('bottom');
    const frameLengthZ = this?.templateJson?.bottom?.length2?.frames?.length;
    let datumPoint = null;
    let sealPlateMesh = null;
    const sealPlateLengthXPos = this.bottomLength1.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.bottom);
    const sealPlateLengthZPos = this.bottomLength2.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.bottom);
    if (!this.bottomLength3) {
      this.bottomLength3 = new LengthP2X(this.templateJson, this.scene, 'bottom', 'length3');
    }
    const sealPlateLengthP2XPos = this.bottomLength3.getSealPlatePos(this.templateJson, BASICTYPE_ENUM.bottom);

    // 移动柜子到指定位置
    this?.templateJson?.bottom?.length1?.frames.forEach((element, index) => {
      // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
      if (index > 0) {
        const preEl = this?.templateJson?.bottom?.length1?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        // 摆放补板后柜体处理
        if (sealPlateMesh && sealPlateLengthXPos && index === sealPlateLengthXPos) {
          datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 1, z: 0 });
        } else {
          datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 });
        }
        const { rotation } = meshManage.moveModelToPosition(datumPoint, {
          x: -1,
          y: 1,
          z: 0,
        });
        this.rotationMeshes[element.componentBasic.id] = rotation;
      } else {
        const { rotation } = putBottomCornerFrame(element, undefined, this.scene);
        this.rotationMeshes[element.componentBasic.id] = rotation;
      }
      if (element.ventilator) {
        let tmpRotation = { x: 0, y: 0, z: 0 };
        // 当前为l1的模型数组 如果灶台在转角柜上面且长边在2 那么旋转 -Math.PI/2
        if (element.longEdge === 2 && element.categoryId === FRAMECATEGORY.CATEGORY_28) {
          tmpRotation = { x: 0, y: -Math.PI / 2, z: 0 };
        }
        this.renderVentilator(element, tmpRotation);
      }
      // 补板处理 需要在摆完柜子之后进行
      if (sealPlateLengthXPos && index === sealPlateLengthXPos - 1) {
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        // 渲染补板
        sealPlateMesh = this.bottomLength1.renderSealPlate(
          sealPlateData.length1, meshManage, BASICTYPE_ENUM.bottom, element,
          this,
        );
        // 获取模型最右边坐标数据
        datumPoint = sealPlateMesh?.getDatumPoint({ x: -1, y: 1, z: 0 });
      }
    });

    datumPoint = null; // 还原默认值
    sealPlateMesh = null; // 还原默认值
    // 特殊处理 U - lengthZ 补办只会放在第一个柜体（length1第一个柜体）后面
    if (!frameLengthZ || frameLengthZ === 1 || !sealPlateLengthZPos || sealPlateLengthZPos) {
      // 摆放补板模型
      const preEl = this?.templateJson?.bottom?.length1?.frames[0];
      const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
      if (sealPlateData.length2.length) {
        sealPlateMesh = this.bottomLength2.renderSealPlate(
          sealPlateData.length2, preMeshManage, BASICTYPE_ENUM.bottom, preEl,
          this,
        );
      }
    }
    this?.templateJson?.bottom?.length2?.frames.forEach((element, index) => {
      // 第一个柜子放在默认位置，第二个开始往外边排列，这个和后台align好的  如果是U_S的话是不用旋转最后一个柜子的
      if (index === this?.templateJson?.bottom?.length2?.frames.length - 1
        && !this?.isUSBottom) {
        // debugger;
        // 处理转角柜  如果l2只有一个的话 pre为l1的第一个柜子   如果有多个的话  pre为l2的倒数第二个柜子
        let preEl = null;
        if (this?.templateJson?.bottom?.length2?.frames.length !== 1) {
          preEl = this?.templateJson?.bottom?.length2?.frames[index - 1];
        } else {
          preEl = this?.templateJson?.bottom?.length1?.frames[0];
        }

        const { rotation } = putBottomCornerFrame(element, preEl, this.scene);
        // 特殊处理只有lenthZ一个转角柜
        if (sealPlateMesh && !sealPlateLengthZPos && frameLengthZ === 1) {
          const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
          meshManage.mesh.position.z += sealPlateMesh.getModelSize().z;
        }
        this.rotationMeshes[element.componentBasic.id] = rotation;
      } else if (index > 0) {
        const preEl = this?.templateJson?.bottom?.length2?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        const { rotation } = meshManage.moveModelToPosition(
          preMeshManage.getDatumPoint({ x: 0, y: 1, z: 1 }),
          { x: 0, y: 1, z: 1 },
        );
        this.rotationMeshes[element.componentBasic.id] = rotation;
      } else {
        const preEl = this?.templateJson?.bottom?.length1?.frames[0];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));

        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        const rotation = meshManage.addRotation(0, -Math.PI / 2, 0);
        this.rotationMeshes[element.componentBasic.id] = rotation;
        // 获取补板尺寸
        const moveSealPlateZ = sealPlateMesh ? sealPlateMesh.getModelSize().z : 0;

        // let position;
        // 128*68转角柜 短边会露出一段，后面拼接柜子需要缩进那一段
        // if (checkIsAfterBottomCornerFrame(index, preEl, element)) {
        //   position = {
        //     x: -meshManage.getModelSize().z * 0.5,
        //     y: SKIRTINGBOARDCONFIG.HEIGHT,
        //     z: meshManage.getModelSize().x * 0.5 + FRAMEDEPTH.BOTTOM,
        //   };
        // } else {
        const position = {
          x: -meshManage.getModelSize().z * 0.5,
          y: SKIRTINGBOARDCONFIG.HEIGHT,
          z: meshManage.getModelSize().x * 0.5 + preMeshManage.getModelSize().z + moveSealPlateZ,
        };
        // }
        meshManage.setModelPosition(
          position,
        );
      }
      if (element.ventilator) {
        let tmpRotation = { x: 0, y: -Math.PI / 2, z: 0 };
        // 当前为l1的模型数组 如果灶台在转角柜上面且长边在2 那么旋转 -Math.PI/2
        if (element.longEdge === 3 && element.categoryId === FRAMECATEGORY.CATEGORY_28) {
          tmpRotation = { x: 0, y: -Math.PI, z: 0 };
        }
        this.renderVentilator(element, tmpRotation);
      }
    });
    // l2为空的时候l3边上的40柜深需要摆放在l2的补板的下一位
    // 所以没有l2的时候不重置l2的补板内容
    if (this?.templateJson?.bottom?.length2.frames.length !== 0) {
      datumPoint = null; // 还原默认值
      sealPlateMesh = null; // 还原默认值
      // 特殊处理 U - lengthZ 只会放在第一个柜体后面
      if (
        (!frameLengthZ || frameLengthZ === 1 || !sealPlateLengthP2XPos)
        && !LengthP2X.checkIsSpecialUType(this.templateJson) // 处理特殊U型情况，不然特殊U型length3补板会渲染两次
      ) {
        // 摆放补板模型
        let preEl = this?.templateJson?.bottom?.length2?.frames[frameLengthZ - 1];
        if (!preEl) {
          preEl = this?.templateJson?.bottom?.length1?.frames[0];
        }
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        if (sealPlateData.length3.length) {
          sealPlateMesh = this.bottomLength3.renderSealPlate(
            sealPlateData.length3, preMeshManage, BASICTYPE_ENUM.bottom, preEl,
            this,
          );
        }
      }
    }

    this?.templateJson?.bottom?.length3?.frames.forEach((element, index) => {
      // 第一个柜子放在默认位置，第二个开始往外边排列，这个和后台align好的
      if (index > 0) {
        const preEl = this?.templateJson?.bottom?.length3?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));

        // 摆放补板后柜体处理   40柜体不需要旋转且需要拿到缩放之后的位置及长度所以传入柜体类型
        if (sealPlateMesh && sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
          datumPoint = sealPlateMesh.getDatumPoint({ x: -1, y: 0, z: 1 }, this?.isUSBottom);
        } else {
          datumPoint = preMeshManage.getDatumPoint({ x: -1, y: 0, z: 1 }, this?.isUSBottom);
        }
        if (this?.isUSBottom) {
          meshManage.mesh.scaling.z = 0.4 / meshManage.getModelSize().z;
        }
        const { rotation } = meshManage.moveModelToPosition(
          datumPoint,
          { x: -1, y: 0, z: 1 },
          this?.isUSBottom, // 传入柜体类型  40柜深不需要旋转
        );
        if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos) {
          meshManage.mesh.position.z += meshManage.getModelSize(this?.isUSBottom).z;
        }
        this.rotationMeshes[element.componentBasic.id] = rotation;
      } else {
        // 判断柜型是不是U_S如果是U_S的话是从外边去摆放放一半柜子进去 里面空的距离目前为定值
        let preEl = this?.templateJson?.bottom?.length2
          ?.frames[this?.templateJson?.bottom?.length2?.frames.length - 1];
        if (!preEl) {
          preEl = this?.templateJson?.bottom?.length1?.frames[0];
        }
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));

        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));

        // 获取补板尺寸

        let position; // 模型位置
        // 如果是小柜子需要将柜体缩放为0.4深度  这个时候就不需要旋转了 （暂未找旋转的地方）
        if (this?.isUSBottom) {
          // 如果是40柜深  那么需要拿到l2的补板的长度  如果l2有柜体的话正常摆放 补板的长度为0
          // 然后进行z轴的便宜
          let moveSealPlateX = 0;
          if (this?.templateJson?.bottom?.length2.frames.length === 0) {
            moveSealPlateX = sealPlateMesh ? sealPlateMesh.getModelSize().z : 0;
          }
          meshManage.mesh.scaling.z = 0.4 / meshManage.getModelSize().z;
          position = {
            x: -0.34 - meshManage.getModelSize().x * 0.5,
            y: SKIRTINGBOARDCONFIG.HEIGHT,
            z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5
            + meshManage.getModelSize(true).z * 0.5 + moveSealPlateX,
          };
        } else {
          // 如果l2有柜体的话 正常摆放
          const moveSealPlateX = sealPlateMesh ? sealPlateMesh.getModelSize().x : 0;
          const rotation = meshManage.addRotation(0, -Math.PI, 0);
          this.rotationMeshes[element.componentBasic.id] = rotation;
          // let position;
          // 128*68转角柜 短边会露出一段，后面拼接柜子需要缩进那一段
          // if (checkIsAfterBottomCornerFrame(index, preEl, element)) {
          //   position = {
          //     x: -meshManage.getModelSize().x * 0.5 - preMeshManage.getModelSize().x * 0.5
          //     + preMeshManage.mesh.position.x + preMeshManage.getModelSize().x - FRAMEDEPTH.BOTTOM,
          //     y: SKIRTINGBOARDCONFIG.HEIGHT,
          //     z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5 - FRAMEDEPTH.BOTTOM * 0.5,
          //   };
          // } else {
          position = {
            x: -meshManage.getModelSize().x * 0.5 - preMeshManage.getModelSize().x * 0.5
              + preMeshManage.mesh.position.x - moveSealPlateX,
            y: SKIRTINGBOARDCONFIG.HEIGHT,
            z: preMeshManage.mesh.position.z + preMeshManage.getModelSize().z * 0.5 - FRAMEDEPTH.BOTTOM * 0.5,
          };
          // }
        }
        meshManage.setModelPosition(
          position,
        );
      }
      if (element.ventilator) {
        this.renderVentilator(element, { x: 0, y: -Math.PI, z: 0 });
      }
      // 补板处理 需要在摆完柜子之后进行
      if (sealPlateLengthP2XPos && index === sealPlateLengthP2XPos - 1) {
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        // 渲染补板
        sealPlateMesh = this.bottomLength3.renderSealPlate(
          sealPlateData.length3, meshManage, BASICTYPE_ENUM.bottom, element,
          this,
        );
      }
    });
  }

  /**
   * @description: 摆放顶柜
   * @param {*}
   * @return {*}
   * @author: Yongchao Wang
   */
  putTopCupboard() {
    const topToGround = TOPFRAME_GROUND(this.templateJson);
    // 移动柜子到指定位置
    this?.templateJson?.top?.length1?.frames.forEach((element, index) => {
      // 第一个柜子放在默认位置，第二个开始往右边排列，这个和后台align好的
      if (index > 0) {
        const preEl = this?.templateJson?.top?.length1?.frames[index - 1];
        const preMeshManage = new MeshManage(this.scene.getMeshByName(preEl.componentBasic.id));
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        const { rotation } = meshManage.moveModelToPosition(
          preMeshManage.getDatumPoint({ x: -1, y: 1, z: 0 }),
          { x: -1, y: 1, z: 0 },
        );
        this.rotationMeshes[element.componentBasic.id] = rotation;
      } else {
        const meshManage = new MeshManage(this.scene.getMeshByName(element.componentBasic.id));
        meshManage.setModelPosition(
          {
            x: -meshManage.getModelSize().x * 0.5,
            y: topToGround - meshManage.getModelSize().y,
            z: meshManage.getModelSize().z * 0.5,
          },
        );
      }
    });
  }

  /**
   * @description: 获取相机最佳位置的参数
   * @param {*}
   * @return {*} {target:Vector3,position:Vector3}
   * @author: Yongchao Wang
   */
  getCameraBestConfig(fov, allMeshes, camera) {
    const max = new Vector3(0, TOPFRAME_GROUND(this.templateJson),
      this.bottomLength2.getSideLength());
    let minx = Math.max(this.bottomLength1.getSideLength(), this.bottomLength3.getSideLength(), MINIMUM_WALL_WIDTH);
    // L1L3尺寸过长时看不到柜深的标线 加上0.8
    minx = minx > MINIMUM_WALL_WIDTH ? minx + 0.8 : minx;

    const min = new Vector3(-minx, 0, 0);
    const size = { x: max.x - min.x, y: max.y - min.y, z: max.z - min.z };
    const target = {
      x: -size.x / 2,
      y: size.y / 2,
      z: size.z / 2,
    };
    const position = {
      y: size.y / 2,
      z: size.z / 2,
    };

    position.x = -(target.y) / Math.tan(fov / 2) - size.x;
    // eslint-disable-next-line no-underscore-dangle
    const ratio = this.scene._engine.getAspectRatio(camera);
    const x = -(target.z) / Math.tan((fov * ratio) / 2) - size.x;
    // 如果是使用纵向视角的x值，那需要远离0.5米给顶部标注一些位置
    position.x = Math.min(x, position.x);
    // const hFov = (fov * ratio) / 2;
    // const deviation = 2 * (Math.PI / 180);
    const lowerAlphaLimit = Math.PI / 2;
    const upperAlphaLimit = Math.PI * 1.5;

    return {
      target: new Vector3(
        target.x,
        target.y,
        target.z,
      ),
      position: new Vector3(
        position.x,
        position.y,
        position.z,
      ),
      lowerAlphaLimit,
      upperAlphaLimit,
      alpha: Math.PI,
      beta: 1.4492930597593832,
    };
  }
}

export default RenderUType;

